	angular
	  .module('vppApp')
	  .service('ProgramInfoService', ProgramInfoService);

	ProgramInfoService.$inject = ['$rootScope'];

	function ProgramInfoService($rootScope) {
	  var ProgramInfoService = {};
	  $rootScope.programData = {};



	  var _createProgramObj = function(programInf) {
	    $rootScope.programData = {
	      program: {
	        programID: programInf.programID,
	        programCode: programInf.code,
	        programName: programInf.name,
			programExp: programInf.programs[0].programInfo.programExpirationDate,
			refreshDate: programInf.programs[0].programInfo.refreshDate,
	        programKBA: programInf.programKBA,
	        programKBAComplete: programInf.programKBAComplete
	      },
	      programInfo: {

	      }
		};
	  };
	  // Recreate data Obj for page refresh
	  var _reCreateProgramObj = function(programInf) {
	    $rootScope.programData = {
	      program: {
	        programID: programInf.programID,
	        programCode: programInf.programCode,
	        programName: programInf.programName,
			programExp: programInf.programs[0].programInfo.programExpirationDate,
			refreshDate: programInf.programs[0].programInfo.refreshDate,
	        programKBA: programInf.programKBA,
	        programKBAComplete: programInf.programKBAComplete
	      },
	      programInfo: {

	      }
	    };
	    // console.log('asdf', programInf);
	  };
	  // recreate Program Details in LS and SS
	  var _reCreateProgramInfoObj = function(programDInf) {
	    var _tempMerge = angular.merge($rootScope.programData.programInfo, $rootScope.programData.programInfo, programDInf);
	  };


	  ProgramInfoService.destroyProgram = function() {
	    window.localStorage.removeItem("vppDataProgram");
	    window.sessionStorage.removeItem('vppDataProgram');
	    $rootScope.programData = {};

	  };
	  ProgramInfoService.addProgram = function(programData) {
	    // console.log(programData.programs[0].programInfo);
	    // create userObj from success 
	    _createProgramObj(programData);
	    var _tempMerge = angular.merge($rootScope.programData.programInfo, $rootScope.programData.programInfo, programData.programs[0].programInfo);
	    // sets localStorage data
	    window.localStorage['vppDataProgram'] = angular.toJson($rootScope.programData);
	    // sets sessionStorage data
	    window.sessionStorage.setItem("vppDataProgram", angular.toJson($rootScope.programData));
	  };

	  ProgramInfoService.addKBA = function(kbaData, kbaCompleteData) {
	    // Get the existing data
	    var existing = ProgramInfoService.getProgramInf();

	    // If no existing data, create an array
	    // Otherwise, convert the localStorage string to an array
	    existing = existing ? angular.fromJson(existing) : {};

	    // Add new data to localStorage Array
	    existing.program.programKBA = kbaData;
	    existing.program.programKBAComplete = kbaCompleteData;


	    // Save back to localStorage
	    localStorage.setItem('vppDataProgram', angular.toJson(existing));
	    window.sessionStorage.setItem("vppDataProgram", angular.toJson(existing));

	  };

	  ProgramInfoService.setProgramData = function(programID) {

	  };

	  ProgramInfoService.getProgramInf = function() {
	    var _getProgramInf = $rootScope.programData;
	    return _getProgramInf;
	  };
	  ProgramInfoService.getProgram = function() {
	    // console.log('getProgram ', $rootScope.programData);
	    var _programID = $rootScope.programData.program.programID;
	    return _programID;
	  };
	  ProgramInfoService.getProgramCode = function() {
	    var _programCode;
	    var programCode = $rootScope.programData.program.programCode;
	    var programInfCode = $rootScope.programData.programInfo.code;
	    if (programCode) {
	      _programCode = programCode;
	    } else if (programInfCode) {
	      _programCode = programInfCode;
	    }


	    return _programCode;
	  };
	  ProgramInfoService.getProgramName = function() {
	    var _programCode = $rootScope.programData.program.programName;
	    return _programCode;
	  };
	  ProgramInfoService.getProgramExp = function() {
	    var _programExp = $rootScope.programData.program.programExp;
	    return _programExp;
	  };

	  ProgramInfoService.getRefreshDate = function() {
		var _refreshDate = $rootScope.programData.program.refreshDate;
	    return _refreshDate;
	  };
	  ProgramInfoService.getProgramKBA = function() {
	    var _programKBA = $rootScope.programData.program.programKBA;
	    return _programKBA;
	  };

	  ProgramInfoService.getProgramInfo = function() {
	    // console.log($rootScope.programData.programInfo);
	    var _programInfo = $rootScope.programData.programInfo;
	    return _programInfo;
	  };

	  ProgramInfoService.checkProgramExists = function() {
	    if (Object.keys($rootScope.programData).length === 0) {
	      // $rootScope.userData is Empty
	      var _tempSPData = angular.fromJson(window.sessionStorage.getItem("vppDataProgram"));
	      var _tempLPData = angular.fromJson(window.localStorage.getItem("vppDataProgram"));

	      if (_tempSPData && _tempLPData) {
	        _reCreateProgramObj(_tempSPData.program);
	        _reCreateProgramInfoObj(_tempSPData.programInfo);

	      } else {
	        this.destroyProgram();
	      }

	      // end
	    }

	  };

	  return ProgramInfoService;


	};
